module.exports = __webpack_public_path__ + "static/img/5.e8eb475.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/5.png
// module id = buoP
// module chunks = 0